import PropTypes from "prop-types";
import { useState } from "react";
import { useIntl } from "react-intl";
import {
  Autocomplete,
  TextField,
} from "@mui/material";

const ArticleNoLookup = ({
  articleNos,
  onChange,
  selectedArticleNo,
}) => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);

  return (
    <Autocomplete
      autoComplete
      filterSelectedOptions
      freeSolo
      fullWidth
      getOptionLabel={(option) => option ?? ""}
      isOptionEqualToValue={(option, value) => option === value}
      loadingText={intl.formatMessage({ id: "common.genericLoading" })}
      noOptionsText=""
      onChange={(_, newArticleNo) => onChange?.(newArticleNo ?? "")}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      options={articleNos ?? []}
      renderInput={(params) => (
        <TextField {...params} fullWidth label={intl.formatMessage({ id: "product.articleNum" })} />
      )}
      renderOption={(props, option) => (
        <li {...props}>{option}</li>
      )}
      size="small"
      value={selectedArticleNo ?? ""}
    />
  );
};

ArticleNoLookup.propTypes = {
  articleNos: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  selectedArticleNo: PropTypes.string,
};

ArticleNoLookup.displayName = "ArticleNoLookup";

export default ArticleNoLookup;
